const locale = {
  summaryHeader: 'Summary',
  orderTax: 'Estimated Tax',
  taxTotal: 'To Be Calculated',
  shipping: 'Shipping',
  shippingFree: 'FREE',
  pretaxTotal: 'Pre-tax Total',
  subtotal: 'Subtotal',
  total: 'Total',
  youllSave: 'You\'ll Save*',
  promoCodeText: '*Apply code <span class="promo-hightlight">{{promoCode}}</span> at checkout. ',
  promoEndDateText: 'Promo valid through <span class="promo-hightlight">{{promoEndDate}}</span>.',
  selectedWindows: 'Selected Items',
  productTotal: 'Product Total',
  addToOrder: 'Add to Order',
};
export default locale;
